import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Device from "./Device";
import DeviceInfo from "./DeviceInfo";
import { DeviceData } from "../models/DeviceData";
import { Message } from "../models/ProtectiveFunctionWrapper";
import { MasterPoolMismatchItem } from "../models/MasterPoolMismatchItem";

interface Props {
  zoom: number;
  devices: Array<DeviceData>;
    handleDeviceClicked: (device: DeviceData, type: string) => void;
    handleDeviceRightClicked: (e: React.MouseEvent, device: DeviceData) => void;
    handleEmptyLogicDeviceLocationClick: () => void;
    errorsAndWarnings: Message[];
    masterPoolMismatchItems?: MasterPoolMismatchItem[];
}

export class LogicConfiguration extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  zoom(value: number, unit: "px" | "em") {
    return `${value * this.props.zoom}${unit}`;
  }

    render() {
        const device = this.props.devices[0];
        const handleDeviceRightClicked = this.props.handleDeviceRightClicked;
        const handleDeviceClicked = this.props.handleDeviceClicked;
        const zoom = this.props.zoom;
        const boxSize = this.zoom(100, "px");
        const imgSize = this.zoom(95, "px");
        const deviceX = this.zoom(100, "px");
        const deviceY = this.zoom(55, "px");
        const infoX = this.zoom(90, "px");
        const infoY = this.zoom(155, "px");

        const fontSize = this.zoom(.9, "em");

        var errorsAndWarnings: Message[] = [];
        if (device != null) {
            const pt = device.ptProtectiveFunction;
            if (this.props.errorsAndWarnings) {
                errorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => c.id === pt.protectiveFunctionID) : false);
            }
        }

        return (
          <div className="logicDiv">
                {device != null ?
                    <div>
                        <DeviceInfo x={infoX} y={infoY} fontSize={fontSize} device={device} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"LSS"} x={deviceX} y={deviceY} boxSize={boxSize} imgWidth={imgSize} imgHeight={imgSize} errorsAndWarnings={errorsAndWarnings} device={device} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                    </div>
                    : <div id="logicBox" style={{ zIndex: 10000, position: "absolute", top: deviceY, left: deviceX, height: boxSize, width: boxSize, backgroundColor: "rgb(255,0,0,0)", pointerEvents: "all" }}
                        onClick={() => this.props.handleEmptyLogicDeviceLocationClick()}
                        onDragOver={e => e.preventDefault()}
                        onDragEnter={e => e.preventDefault()}
                        onDrop={() => this.props.handleEmptyLogicDeviceLocationClick()} />
                }
          </div>
        );
  }
}